import React from "react";
import { Modal, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import RowContainer from "./RowContainer";
import { CloseRounded } from "@mui/icons-material";

const ModalDiv = styled(Modal)(({ minHeight }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  height: "100%",
  zIndex: 5,
  top: "40px",
  [`@media screen and (max-width: 600px)`]: {
    top: "5px",
  },
  "& .modal-form-container": {
    minHeight: minHeight ?? "50vh",
    padding: "20px",
    margin: "20px",
    borderRadius: "10px",
    backgroundColor: "var(--bkg-primary)",
    display: "flex",
    flexDirection: "column",
    "& > div": {
      justifyContent: "flex-end",
    },
    "& .MuiSvgIcon-root": {
      color: "var(--text-primary)",
    },
    [`@media screen and (max-width: 600px)`]: {
      padding: "8px",
    },
  },
}));

const ModalComponent = ({
  className,
  open,
  handleClose,
  children,
  minHeight,
}) => {
  return (
    <ModalDiv open={open} onClose={handleClose} closeAfterTransition minHeight>
      <div className={`modal-form-container ${className}`}>
        <RowContainer>
          <IconButton onClick={handleClose}>
            <CloseRounded fontSize="medium" />
          </IconButton>
        </RowContainer>
        {children}
      </div>
    </ModalDiv>
  );
};

export default ModalComponent;
